module.exports = __webpack_public_path__ + "img/mrt.7f62dd06.jpg";